export const isCursorPointer = (value) =>
	value ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
